import React from "react";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";
import ToggleButtonGroup from "../../../sharedComponents/toggleButtonGroup/toggleButtonGroup";
import { NumberOfDamagesInLastThreeYearsId } from "../../../../helpers/additionalQuestions/numberOfDamagesInLastThreeYears";
import { PolicyStore } from "../../../../stores/policyStore";

interface NumberOfDamagesInLastThreeYearsProps {
    calculateStore?: CalculateStore;
    policyStore?: PolicyStore;
}

export function NumberOfDamagesInLastThreeYears(props: NumberOfDamagesInLastThreeYearsProps) {
    const calculateStore = props.calculateStore!;
    const numberOfDamages = calculateStore.additionalQuestions.numberOfDamagesInLastThreeYears;

    const onChangeValue = (newValue: string) => {
        if (newValue) {
            calculateStore.setNumberOfDamagesInLastThreeYears(newValue as NumberOfDamagesInLastThreeYearsId);
            validate();
        }
    };

    return (
        <div className="number-of-damages-in-last-three-years">
            <div className="question-answer-container">
                <ToggleButtonGroup
                    disabled={!numberOfDamages.editable}
                    errorMessage={numberOfDamages.errorMessage}
                    onChange={onChangeValue}
                    options={[
                        {
                            value: NumberOfDamagesInLastThreeYearsId.zero,
                            label: "0"
                        },
                        {
                            value: NumberOfDamagesInLastThreeYearsId.one,
                            label: "1"
                        },
                        {
                            value: NumberOfDamagesInLastThreeYearsId.two,
                            label: "2"
                        },
                        {
                            value: NumberOfDamagesInLastThreeYearsId.threeOrMore,
                            label: "3+"
                        }
                    ]}
                    question="Liczba szkód w ostatnich 3 latach"
                    value={numberOfDamages.value}
                    contextHelp={"Zaznacz liczbę szkód, które łącznie zostały wypłacone w ciągu ostatnich 3 lat zarówno " +
                        "z mienia jak i z OC w życiu prywatnym, bez względu na Ubezpieczyciela"} />
            </div>
        </div>
    );

    function validate() {
        numberOfDamages.validateNumberOfDamagesInLastThreeYears();
    }
}

export default inject("calculateStore", "policyStore")(observer(NumberOfDamagesInLastThreeYears));
